import React from 'react';
import { useTranslation } from 'react-i18next';

import ContentSizedTextarea from 'components/layout/forms/ContentSizedTextarea';

import translations from '../../../../../services/translations/translations';

const Memo = ({
  locked,
  memo,
  onTextInputChanged,
}: {
  locked: boolean;
  memo: string;
  onTextInputChanged: (value: string) => void;
}): JSX.Element => {
  const { t } = useTranslation([translations.offers]);

  const offerIsLocked = () => locked;

  return (
    <ContentSizedTextarea
      className="calculation-window-memo"
      disabled={offerIsLocked()}
      id="memo"
      label={t('Memo')}
      name="text"
      onChange={(e) => onTextInputChanged(e.target.value)}
      value={memo === null ? '' : memo}
    />
  );
};

export default Memo;
